import optionSetTemplate from './templates/option_set.tpl.html';
import dayRangeBookingsTemplate from './templates/day_range_bookings.tpl.html';
import timeReservedTemplate from './templates/time_reserved.tpl.html';

import moment from 'moment';

export default class AlBoPreviewController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');

        this.typeTemplates = {
            option_set: optionSetTemplate,
            day_range_bookings: dayRangeBookingsTemplate,
            time_reserved: timeReservedTemplate
        };
        this.boInformation = [];
        this.loading = true;
        this.dayRangeData = {};

        this._initWatchers();
    }

    shouldDisplay(bookedObject) {
        switch (bookedObject.object.type) {
            case 'option_set':
            case 'day_range_bookings':
            case 'time_reserved':
                return bookedObject.options.length > 0;
            default:
                return true;
        }
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.rsvpId;
        }, () => {
            if (this.rsvpId) {
                this._updateObjectInformation();
            }
        });

        this.scope.$watch(() => {
            return this.rsvpSeatplanElementId;
        }, () => {
            this._updateObjectInformation();
        });

        this.scope.$watch(() => {
            return this.includeRseLinks;
        }, () => {
            this._updateObjectInformation();
        });
    }

    _updateObjectInformation() {
        if (!this.rsvpId) {
            return;
        }

        this.loading = true;
        this.api.get(`bo/rsvps/${this.rsvpId}/option-links${(this.rsvpSeatplanElementId) ? '/' + this.rsvpSeatplanElementId : ''}?includeRseLinks=${this.includeRseLinks ? 1 : 0}`).then((response) => {
            this.boInformation = _.get(response, 'data.data');
            this.prepareSpecialObjectData();
            this.loading = false;
            this.scope.$applyAsync();
        });
    }

    calculateAmountForOptionSetOption(option) {
        let amount = 0;

        _.each(option.option_links, (optionLink) => {
            amount += optionLink.amount;
        });

        return amount;
    }

    prepareSpecialObjectData() {
        this.dayRangeData = {};

        _.each(this.boInformation, (objectInformation) => {
            switch (objectInformation.object.type) {
                case 'day_range_bookings':
                    this.dayRangeData[objectInformation.object.uuid] = this.getSortedForDayRangeBookings(objectInformation);
                    break;
            }
        });
    }

    getSortedForDayRangeBookings(objectInformation) {
        const out = [];

        _.each(objectInformation.options, (option) => {
            _.each(option.option_links, (optionLink) => {
                out.push({
                    label: option.option.label,
                    start_date: optionLink.start_date,
                    end_date: optionLink.end_date
                });
            });
        });

        out.sort((a,b) => {
           return moment(a.start_date) - moment(b.start_date);
        });

        return out;
    }
}

AlBoPreviewController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/al-bo-preview/controller.js